<template>
  <div :class="['row mb-2 gx-2', props.class]">
    <slot></slot>
  </div>
</template>
<script setup>
const props = defineProps({
  class: {
    type: String,
    default: 'align-items-center'
  } 
});
</script>